import { Route } from 'react-router-dom';
import { FeatureRoute } from '../components/auth/FeatureRoute.js';
import { ManageRoute } from '../components/auth/ManageRoute.js';
import { MyTasksPage, TaskReportPage, TaskTemplatesPage, TasksBoardPage } from '../lazyPages.js';

/* ===========================================================================
 * STAFF TASKS — two doors, the letters shape. docs/plans/staff-tasks.md.
 * A fragment for the reason `approvalDoorRoutes.tsx` gives (App.tsx is size
 * debt behind a ratchet); spliced in as `{TASK_ROUTES}` and re-inlined for the
 * route-gate suites by `test/appRouteSource.ts`.
 *
 * `/tasks` is the person's own list — gated by the feature only, so visiting
 * it never flips anyone into the Admin panel. `/tasks/manage` is the board,
 * permission-gated so the rail can carry it under People. Its templates sit
 * UNDER it (`/tasks/manage/templates`), so the board's rail row claims the
 * page and `isAdminPath` keeps the admin chrome without a second rail row.
 * The report (`/tasks/manage/report`) sits under it for the same reason.
 * ======================================================================== */
export const TASK_ROUTES = (
  <>
    <Route
      path="tasks"
      element={
        <FeatureRoute feature="tasks">
          <MyTasksPage />
        </FeatureRoute>
      }
    />
    <Route
      path="tasks/manage"
      element={
        <ManageRoute permission="tasks.view" feature="tasks">
          <TasksBoardPage />
        </ManageRoute>
      }
    />
    <Route
      path="tasks/manage/templates"
      element={
        <ManageRoute permission="tasks.view" feature="tasks">
          <TaskTemplatesPage />
        </ManageRoute>
      }
    />
    <Route
      path="tasks/manage/report"
      element={
        <ManageRoute permission="tasks.view" feature="tasks">
          <TaskReportPage />
        </ManageRoute>
      }
    />
  </>
);
